import axios from "axios";
import { store } from "../Redux/Store/index.js";
import { SignIn, LogOut } from "../Redux/Actions"
import i18n from "../Config/i18n.js";
axios.defaults.maxContentLength = 500000;

let json
try {
    json = localStorage.getItem('user');
} catch (error) {
    console.log(error)
}
const user = json !== 'undefined' && json ? JSON.parse(json) : null;
const Url = process.env.REACT_APP_BASEURL ? process.env.REACT_APP_BASEURL : "https://api.augenengenharia.com/";

let SSO_url = "https://auth.biosolvit.com/api";
try {
    SSO_url = process.env.REACT_APP_SSO_URL ? process.env.REACT_APP_SSO_URL : "https://auth.biosolvit.com/api";
} catch (error) {
    SSO_url = "https://auth.biosolvit.com/api";
}

const api = axios.create({
    baseURL: Url,
    
    timeout: 30000,
    headers: {'Accept': 'application/json', "Content-Type": "application/json"},
})

// "ngrok-skip-browser-warning" : true
api.defaults.headers.common['Authorization'] = user ? 'Bearer ' +user.access_token : null;

function setJWTToken (token: string){
    api.defaults.headers.common['Authorization'] = 'Bearer ' +token ;
}

// Controle de concorrência
let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token: string | null = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            if (isRefreshing) {
                return new Promise(function (resolve, reject) {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers["Authorization"] = "Bearer " + token;
                        return api(originalRequest);
                    })
                    .catch((err) => {
                        return Promise.reject(err);
                    });
            }

            isRefreshing = true;

            try {
                const currentUserStr = localStorage.getItem("user");
                const currentUser = currentUserStr ? JSON.parse(currentUserStr) : null;

                if (!currentUser) {
                    throw new Error("No user available for refresh");
                }

                const clientKey =
                    process.env.REACT_APP_CLIENT_KEY || "7k5jh32235jhbnrr18bco0pgpj";

                const payload: any = {
                    user_id: currentUser.user?.cognito_id,
                };
                if (currentUser.refresh_token) {
                    payload.refresh_token = currentUser.refresh_token;
                }

                const { data } = await axios.post(
                    `${SSO_url}/refreshToken`,
                    payload,
                    {
                        headers: {
                            "X-Client-key": clientKey,
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        withCredentials: true
                    },
                );

                const newToken = data.access_token;

                setJWTToken(newToken);

                currentUser.access_token = newToken;
                if (data.refresh_token) {
                    currentUser.refresh_token = data.refresh_token;
                }
                localStorage.setItem("user", JSON.stringify(currentUser));

                store.dispatch(SignIn(currentUser));

                processQueue(null, newToken);

                originalRequest.headers["Authorization"] = "Bearer " + newToken;
                return api(originalRequest);

            } catch (refreshError) {
                processQueue(refreshError, null);
                setJWTToken("");
                localStorage.removeItem("user");
                store.dispatch(LogOut());
                return Promise.reject(new Error(i18n.t("errors.unauthenticated")));
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    },
);

export { api, setJWTToken };